import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { FaEye, FaClock } from 'react-icons/fa';
import moment from 'moment';
import { apiURL1 } from '../../config';
import Footer from "components/Footers/Footer";


const MarkAttendance = () => {
    const token = localStorage.getItem("token");

    const [userId, setUserId] = useState('');
    const [allAttendanceData, setAllAttendanceData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [overtimeModalOpen, setOvertimeModalOpen] = useState(false);
    const [confirmCheckInModalOpen, setConfirmCheckInModalOpen] = useState(false);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const [overtimeHours, setOvertimeHours] = useState('');
    const [notes, setNotes] = useState('');
    const [breakDetailsModalOpen, setBreakDetailsModalOpen] = useState(false);
    const [selectedBreaks, setSelectedBreaks] = useState([]);

    const [filterDate, setFilterDate] = useState('');
    const [filterOvertimeStatus, setFilterOvertimeStatus] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const recordsPerPage = 20;

    useEffect(() => {
        const user = localStorage.getItem('userInfo');
        if (user) {
            const parsedUser = JSON.parse(user);
            setUserId(parsedUser._id);
        }
    }, []);

    useEffect(() => {
        if (userId) {
            fetchAllAttendanceData();
        }
    }, [userId, filterDate, filterOvertimeStatus, filterStatus]);

    const fetchAllAttendanceData = async () => {
        try {
            let url = `${apiURL1}/teacher/${userId}/attendance`;
            if (filterDate) {
                url += `?date=${moment(filterDate).format('DD-MM-YYYY')}`;
            }
            if (filterOvertimeStatus) {
                url += `${filterDate ? '&' : '?'}overtimeStatus=${filterOvertimeStatus}`;
            }
            if (filterStatus) {
                url += `${filterDate || filterOvertimeStatus ? '&' : '?'}status=${filterStatus}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                    // Any other headers can go here
                },
            });
            const data = await response.json();
            // console.log('Data is ', data.attendance)
            setAllAttendanceData(data.attendance || []);
        } catch (error) {
            // console.error('Error fetching attendance data:', error);
            toast.error('Error fetching attendance data!');
        }
    };

    // const handleCheckIn = async () => {
    //     try {
    //         const today = moment().format('DD-MM-YYYY');
    //         const existingAttendance = allAttendanceData.find(
    //             (record) => moment(record.date).format('DD-MM-YYYY') === today
    //         );

    //         if (existingAttendance && existingAttendance.checkIn && existingAttendance.checkOut) {
    //             setConfirmCheckInModalOpen(true);
    //         } else if (existingAttendance && existingAttendance.checkIn && !existingAttendance.checkOut) {
    //             toast.warn('You have already checked in today but have not checked out yet.');
    //         } else {
    //             await performCheckIn(false);
    //         }
    //     } catch (error) {
    //         console.error('Error during check-in:', error);
    //         toast.error('Error during check-in!');
    //     }
    // };

    const performCheckIn = async (forceCheckIn) => {
        try {
            await fetch(`${apiURL1}/teacher/${userId}/attendance/checkin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({ forceCheckIn: forceCheckIn }),
            });
            toast.success('Checked in successfully!');
            fetchAllAttendanceData();
        } catch (error) {
            console.error('Error during check-in:', error);
            toast.error('Error during check-in!');
        } finally {
            setConfirmCheckInModalOpen(false);
        }
    };

    // const handleCheckOut = async (attendanceId) => {
    //     try {
    //         const response = await fetch(
    //             `${apiURL1}/teacher/${userId}/attendance/checkout/${attendanceId}`,
    //             {
    //                 method: 'POST',
    //                 headers: {
    //                     'Authorization': `Bearer ${token}`, // Add token to headers
    //                     // Any other headers can go here
    //                 },
    //             }
    //         );
    //         if (response.ok) {
    //             toast.success('Checked out successfully!');
    //             fetchAllAttendanceData();
    //         } else {
    //             const errorData = await response.json();
    //             toast.error(errorData.message || 'Error during check-out!');
    //         }
    //     } catch (error) {
    //         console.error('Error during check-out:', error);
    //         toast.error('Error during check-out!');
    //     }
    // };

    const handleRequestOvertime = async (attendanceId) => {
        try {
            const response = await fetch(
                `${apiURL1}/teacher/${userId}/attendance/overtime/${attendanceId}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`, // Add token to headers

                    },
                    body: JSON.stringify({ hours: overtimeHours, notes: notes }),
                }
            );
            if (response.ok) {
                toast.success('Overtime request submitted successfully!');
                fetchAllAttendanceData();
                setOvertimeHours('');
                setNotes('')
                setOvertimeModalOpen(false);
            } else {
                toast.error('Error submitting overtime request!');
            }
        } catch (error) {
            console.error('Error submitting overtime request:', error);
            toast.error('Error submitting overtime request!');
        }
    };

    const handleViewAttendance = (attendance) => {
        setSelectedAttendance(attendance);
        setViewModalOpen(true);
    };

    const closeViewModal = () => {
        setSelectedAttendance(null);
        setViewModalOpen(false);
    };

    const closeOvertimeModal = () => {
        setSelectedAttendance(null);
        setOvertimeModalOpen(false);
    };

    const handleOpenOvertimeModal = (attendance) => {
        setSelectedAttendance(attendance);
        setOvertimeModalOpen(true);
    };

    const closeConfirmCheckInModal = () => {
        setConfirmCheckInModalOpen(false);
    };

    const calculateTotalHours = (checkIn, checkOut) => {
        if (!checkIn || !checkOut) return '-';
        const checkInTime = moment(checkIn);
        const checkOutTime = moment(checkOut);
        const duration = moment.duration(checkOutTime.diff(checkInTime));
        const hours = duration.asHours();
        return hours.toFixed(2);
    };

    const formatTotalBreakTime = (totalBreakTime) => {
        return totalBreakTime ? `${totalBreakTime}h` : '-';
    };

    const filterAttendanceData = () => {
        let filteredData = [...allAttendanceData];

        if (filterDate) {
            filteredData = filteredData.filter((record) =>
                moment(record.date).isSame(filterDate, 'day')
            );
        }

        if (filterOvertimeStatus) {
            filteredData = filteredData.filter(
                (record) =>
                    record.overtime &&
                    record.overtime.requestStatus === filterOvertimeStatus
            );
        }

        if (filterStatus) {
            filteredData = filteredData.filter(
                (record) => record.status && record.status.toLowerCase() === filterStatus.toLowerCase()
            );
        }
        return filteredData;
    };

    const sortAttendanceData = (data) => {
        return [...data].sort((a, b) => {
            const dateA = moment(a.date);
            const dateB = moment(b.date);
            if (dateA.isAfter(dateB)) return -1;
            if (dateB.isAfter(dateA)) return 1;

            const checkInA = a.checkIn ? moment(a.checkIn) : moment(0);
            const checkInB = b.checkIn ? moment(b.checkIn) : moment(0);
            if (checkInA.isAfter(checkInB)) return -1;
            if (checkInB.isAfter(checkInA)) return 1;
            return 0;
        });
    };

    const filteredAttendanceData = filterAttendanceData();
    const sortedAttendanceData = sortAttendanceData(filteredAttendanceData);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedAttendanceData.slice(
        indexOfFirstRecord,
        indexOfLastRecord
    );
    const totalPages = Math.ceil(
        sortedAttendanceData.length / recordsPerPage
    );

    const renderPagination = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i)}>
                        {i}
                    </button>
                </li>
            );
        }
        return (
            <nav>
                <ul className="pagination justify-content-center">{pages}</ul>
            </nav>
        );
    };

    const toggleBreakDetailsModal = (breaks) => {
        setSelectedBreaks(breaks);
        setBreakDetailsModalOpen(!breakDetailsModalOpen);
    };

    const closeBreakDetailsModal = () => {
        setSelectedBreaks([]);
        setBreakDetailsModalOpen(false);
    };

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: '600px',
                    backgroundImage:
                        'url(' + require('../../assets/img/theme/alRehman.jpg') + ')',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-2 text-white">Mark Attendance</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage your daily attendance efficiently.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Attendance Records</h3>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-3">
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Filter by Date</Label>
                                            <Input
                                                type="date"
                                                value={filterDate}
                                                onChange={(e) => setFilterDate(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Overtime Status</Label>
                                            <Input
                                                type="select"
                                                value={filterOvertimeStatus}
                                                onChange={(e) => setFilterOvertimeStatus(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                <option value="pending">Pending</option>
                                                <option value="approved">Approved</option>
                                                <option value="rejected">Rejected</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Status</Label>
                                            <Input
                                                type="select"
                                                value={filterStatus}
                                                onChange={(e) => setFilterStatus(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                <option value="present">Present</option>
                                                <option value="absent">Absent</option>
                                                <option value="leave">Leave</option>

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Date</th>
                                            <th>Check-in Time</th>
                                            <th>Check-out Time</th>
                                            <th>Total Hours</th>
                                            <th>Total Break Time</th>
                                            <th>Status</th>
                                            <th>Day Status</th>
                                            <th>Is Late</th>
                                            <th>Is Approve</th>
                                            <th>Overtime Request Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.map((record) => (
                                            <tr key={record._id}>
                                                <td>
                                                    {record.date
                                                        ? moment(record.date).format('DD-MM-YYYY')
                                                        : '-'}
                                                </td>
                                                <td>
                                                    {record.checkIn
                                                        ? moment(record.checkIn).format('hh:mm A')
                                                        : '-'}
                                                </td>
                                                <td>
                                                    {record.checkOut
                                                        ? moment(record.checkOut).format('hh:mm A')
                                                        : '-'}
                                                </td>
                                                <td>{record.totalWorkingHours || '-'}</td>
                                                <td
                                                    style={{ cursor: 'pointer', color: 'blue' }}
                                                    onClick={() => toggleBreakDetailsModal(record.breaks)}
                                                >
                                                    {record.totalBreakTime || '-'}
                                                </td>
                                                <td>{record.status || '-'}</td>
                                                <td>{record.dayStatus || '-'}</td>
                                                <td>{record.isLate ? 'Yes' : 'No'}</td>
                                                <td>{record.isApprove ? 'Yes' : 'No'}</td>
                                                <td>{record.overtime?.requestStatus || '-'}</td>
                                                <td className="d-flex flex-wrap gap-1">

                                                    {!record.overtime && record.checkIn && record.checkOut && (
                                                        <Button color="info" size="sm" onClick={() => handleOpenOvertimeModal(record)} className="p-1 d-flex align-items-center mb-2">
                                                            <FaClock className="me-1" style={{ fontSize: "0.8rem" }} />
                                                            <span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Request Overtime</span>
                                                        </Button>
                                                    )}

                                                    <Button color="secondary" size="sm" onClick={() => handleViewAttendance(record)}>
                                                        <FaEye className="me-1" /> View
                                                    </Button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {renderPagination()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={overtimeModalOpen} toggle={closeOvertimeModal}>
                <ModalHeader toggle={closeOvertimeModal}>
                    Request Overtime
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault();
                            if (selectedAttendance) {
                                handleRequestOvertime(selectedAttendance._id);
                            }
                        }}
                    >
                        <FormGroup>
                            <Label>Overtime Hours</Label>
                            <Input
                                type="number"
                                placeholder="Enter number of hours"
                                value={overtimeHours}
                                onChange={(e) => setOvertimeHours(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Note for Overtime</Label>
                            <Input
                                type="text"
                                placeholder="Enter notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Submit Request
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeOvertimeModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={viewModalOpen} toggle={closeViewModal}>
                <ModalHeader toggle={closeViewModal}>Attendance Details</ModalHeader>
                <ModalBody>
                    {selectedAttendance && (
                        <div>
                            <p>
                                Date:{' '}
                                {selectedAttendance.date
                                    ? moment(selectedAttendance.date).format('DD-MM-YYYY')
                                    : '-'}
                            </p>
                            <p>
                                Check-in Time:{' '}
                                {selectedAttendance.checkIn
                                    ? moment(selectedAttendance.checkIn).format('hh:mm A')
                                    : '-'}
                            </p>
                            <p>
                                Check-out Time:{' '}
                                {selectedAttendance.checkOut
                                    ? moment(selectedAttendance.checkOut).format('hh:mm A')
                                    : '-'}
                            </p>
                            <p>
                                Total Hours:{' '}
                                {selectedAttendance.totalWorkingHours || '-'}
                            </p>
                            <p>Total Break Time: {selectedAttendance.totalBreakTime || '-'}</p>
                            <p>Status: {selectedAttendance.status || '-'}</p>
                            <p>Day Status: {selectedAttendance.dayStatus || '-'}</p>
                            <p>Is Late: {selectedAttendance.isLate ? 'Yes' : 'No'}</p>
                            <p>Is Approve: {selectedAttendance.isApprove ? 'Yes' : 'No'}</p>
                            {selectedAttendance.overtime ? (
                                <>
                                    <p>
                                        Overtime Hours: {selectedAttendance.overtime.hours || '-'}
                                    </p>
                                    <p>
                                        Overtime Request Status:{' '}
                                        {selectedAttendance.overtime.requestStatus || '-'}
                                    </p>
                                    <p>
                                        Overtime Request Date:{' '}
                                        {selectedAttendance.overtime.requestDate
                                            ? moment(selectedAttendance.overtime.requestDate).format(
                                                'DD-MM-YYYY hh:mm A'
                                            )
                                            : '-'}
                                    </p>
                                </>
                            ) : (
                                <p>No Overtime Requested</p>
                            )}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeViewModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={breakDetailsModalOpen} toggle={closeBreakDetailsModal}>
                <ModalHeader toggle={closeBreakDetailsModal}>Break Details</ModalHeader>
                <ModalBody>
                    {selectedBreaks && selectedBreaks.length > 0 ? (
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedBreaks.map((breakItem) => (
                                    <tr key={breakItem._id}>
                                        <td>{breakItem.start ? moment(breakItem.start).format('hh:mm A') : '-'}</td>
                                        <td>{breakItem.end ? moment(breakItem.end).format('hh:mm A') : '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No break details available.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeBreakDetailsModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={confirmCheckInModalOpen} toggle={closeConfirmCheckInModal}>
                <ModalHeader toggle={closeConfirmCheckInModal}>
                    Confirm Check-in
                </ModalHeader>
                <ModalBody>
                    <p>Do you want to check in again?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => performCheckIn(true)}>
                        Yes
                    </Button>
                    <Button color="secondary" onClick={closeConfirmCheckInModal}>
                        No
                    </Button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

export default MarkAttendance;

